(function () {
  /* =========================================================================
     Rebuy sale-price overrides
     -------------------------------------------------------------------------
     Rebuy caches its own catalogue, so it can show full price during a sale.
     This rewrites the price Rebuy displays. Matching is by Shopify ID and is
     widget-agnostic (every Rebuy widget on the page is covered).

     WHOLE-PRODUCT (every colour of the product is on sale) -> key by PRODUCT id:
       FIXED  = exact sale price   (product has a compare-at in Rebuy)
       PCT    = percent off        (product has no compare-at in Rebuy)

     PER-COLOUR (only some colour/size variants are on sale, e.g. plates) ->
     key by VARIANT id. The script reads the variant currently selected in the
     Rebuy card and only discounts it; other colours keep their normal price:
       FIXED_VARIANT = exact sale price for that variant
       PCT_VARIANT   = percent off for that variant
     Because PCT works off the displayed price, different prices (1pk vs 3pk)
     are each discounted correctly — no need to hardcode per-pack amounts.
     ========================================================================= */

  /* Whole-product, with compare-at in Rebuy */
  var FIXED = {
    7175297957934: 99.99,
    7175295893550: 61.39,
    7175294386222: 52.99,
    7175294124078: 49.99,
    7175292911662: 49.99,
    7175190904878: 74.99,
    7175190380590: 74.99,
    7175298940974: 74.99,
    7097927827502: 49.99,
    7111992606766: 51.99,
    7173394792494: 62.99,
    7173665521710: 22.03,
    7173670404142: 23.03,

    /* New bundles (Sep 2026) — compare-at present in Rebuy */
    7642451738670: 24.72,
    7597281574958: 63.99,
    7597282426926: 69.99,
    7597284556846: 43.99
  };

  /* Whole-product, no compare-at in Rebuy (percent as a decimal) */
  var PCT = {
    6892568543278: 0.20,
    7108991189038: 0.20
  };

  /* Per-colour sale: exact price, keyed by VARIANT id (compare-at in Rebuy) */
  var FIXED_VARIANT = {
    // 41234567890123: 24.72,
  };

  /* Per-colour sale: percent off, keyed by VARIANT id (no compare-at in Rebuy) */
  var PCT_VARIANT = {
    41459799916590: 0.20, 
    41416355184686: 0.20, 
    41416358363182: 0.20, 
    41416361181230: 0.20, 
    41416367276078: 0.20, 
    41416376909870: 0.20, 
    40343241752622: 0.20,
    40343241785390: 0.20,
    42331356626990: 0.20,
    42331356659758: 0.20,
    41392189210670: 0.35,
    41392189243438: 0.35,
    41392189276206: 0.35,
    41163590238254: 0.25,
    41163590271022: 0.25,
    41163590303790: 0.25,
    39409296834606: 0.20,
    39409296867374: 0.20,
    39409296769070: 0.20,
    39663154724910: 0.20,
    39663154757678: 0.20,
    39828093173806: 0.20,
    40170948034606: 0.20,
    41082664976430: 0.20,
    41082665009198: 0.20,
    42231394598958: 0.15,
    42231394631726: 0.15,
    42231394697262: 0.15,
    42231394730030: 0.15
  };

  /* Handle-based lookup for PDP addon widgets to bypass hidden Product IDs */
  var ADDON = {
    'omiebox-up-dip-utensil-set-copy': 22.03,
    'omie-up-dip-utensil-set': 23.03,
    'omiebox-dip-omiebox-lite-dip': 24.72

  };

  function fmt(n) {
    return '$ ' + n.toFixed(2);
  }

  function getProductId(block) {
    try {
      var vEl = block.__vue__ ? block : block.querySelector('[__vue__]');
      if (vEl && vEl.__vue__ && vEl.__vue__.item && vEl.__vue__.item.product) {
        return parseInt(vEl.__vue__.item.product.id, 10);
      }
    } catch (e) {}
    var m = block.className.match(/product-id-(\d+)/);
    if (m) return parseInt(m[1], 10);
    var el = block.querySelector('[data-product-id]');
    if (el && /^\d+$/.test(el.getAttribute('data-product-id'))) {
      return parseInt(el.getAttribute('data-product-id'), 10);
    }
    return null;
  }

  /* The variant currently selected in this Rebuy card, parsing hidden/Vue fields */
  function getSelectedVariantId(block) {
    try {
      var vEl = block.__vue__ ? block : block.querySelector('[__vue__]');
      if (vEl && vEl.__vue__) {
        var v = vEl.__vue__;
        if (v.item && v.item.selected_variant) return parseInt(v.item.selected_variant.id, 10);
        if (v.product && v.product.selected_variant) return parseInt(v.product.selected_variant.id, 10);
      }
    } catch (e) {}
    
    var sel = block.querySelector('select');
    if (sel && /^\d{10,}$/.test(sel.value)) return parseInt(sel.value, 10);
    
    var input = block.querySelector('input[type="radio"]:checked, input[type="checkbox"]:checked, input[name="id"], input[name="variant_id"]');
    if (input && /^\d{10,}$/.test(input.value)) return parseInt(input.value, 10);
    
    var attrNames = ['data-variant-id', 'data-variant', 'data-id'];
    for (var i = 0; i < attrNames.length; i++) {
      var el = block.querySelector('[' + attrNames[i] + ']');
      if (el && /^\d{10,}$/.test(el.getAttribute(attrNames[i]))) {
        return parseInt(el.getAttribute(attrNames[i]), 10);
      }
    }
    var m = block.className.match(/variant-id-(\d+)/);
    if (m) return parseInt(m[1], 10);
    return null;
  }

  function getAddonHandle(block) {
    var link = block.querySelector('.rebuy-addon__item-learn-more-link, .rebuy-addon__item-learn-more a, a.rebuy-product-title');
    if (!link) return null;
    var href = link.getAttribute('href');
    if (!href) return null;
    var m = href.match(/\/products\/([^?\/]+)/);
    return m ? m[1] : null;
  }

  function parsePrice(text) {
    return parseFloat(text.replace(/[^0-9.]/g, ''));
  }

  function cleanBlock(block) {
    block.querySelectorAll('.rebuy-money.compare-at.sale-injected').forEach(function (el) {
      el.remove();
    });
    block.querySelectorAll('.rebuy-money.sale-applied').forEach(function (el) {
      el.classList.remove('sale', 'sale-applied');
      var target = el.querySelector('span:not(.sr-only)') || el;
      if (target && target.dataset.origPrice) {
        target.textContent = fmt(parseFloat(target.dataset.origPrice));
        delete target.dataset.origPrice;
      }
    });
  }

  function applyFixed(block, price) {
    var money = block.querySelector('.rebuy-money:not(.compare-at)');
    if (!money) return false;
    var target = money.querySelector('span:not(.sr-only)') || money;
    
    if (!target.dataset.origPrice) {
      target.dataset.origPrice = parsePrice(target.textContent);
    }
    
    target.textContent = fmt(price);
    money.classList.add('sale', 'sale-applied');
    return true;
  }

  function applyPct(block, pct) {
    var money = block.querySelector('.rebuy-money:not(.compare-at)');
    if (!money) return false;
    var target = money.querySelector('span:not(.sr-only)') || money;
    
    var orig = target.dataset.origPrice ? parseFloat(target.dataset.origPrice) : parsePrice(target.textContent);
    if (isNaN(orig) || orig === 0) return false;
    target.dataset.origPrice = orig; 
    
    var sale = Math.round(orig * (1 - pct) * 100) / 100;
    target.textContent = fmt(sale);
    money.classList.add('sale', 'sale-applied');
    
    if (!block.querySelector('.rebuy-money.compare-at')) {
      var cmp = document.createElement('span');
      cmp.className = 'rebuy-money compare-at sale-injected';
      cmp.innerHTML = '<span class="sr-only">Original price</span> <span>' + fmt(orig) + '</span>';
      money.parentNode.insertBefore(cmp, money.nextSibling);
    }
    return true;
  }

  function applyOverrides() {
    document.querySelectorAll('.rebuy-product-block, .rebuy-addon__item').forEach(function (block) {
      var pid = getProductId(block);
      var vid = getSelectedVariantId(block);
      var handle = block.classList.contains('rebuy-addon__item') ? getAddonHandle(block) : null;

      var vFixed = vid != null ? FIXED_VARIANT[vid] : undefined;
      var vPct   = vid != null ? PCT_VARIANT[vid]   : undefined;
      var hFixed = handle != null ? ADDON[handle] : undefined;
      var pFixed = pid != null ? FIXED[pid] : undefined;
      var pPct   = pid != null ? PCT[pid]   : undefined;

      var mode = null, key = null;
      
      /* Hierarchy: Variant rules first, then Addon handle rules, then Parent Product rules */
      if (vFixed !== undefined)      { mode = 'fixed'; key = 'v' + vid; }
      else if (vPct !== undefined)   { mode = 'pct';   key = 'v' + vid; }
      else if (hFixed !== undefined) { mode = 'fixed'; key = 'h' + handle; } 
      else if (pFixed !== undefined) { mode = 'fixed'; key = 'p' + pid; }
      else if (pPct !== undefined)   { mode = 'pct';   key = 'p' + pid; }

      if (key === null) {
        if (block.dataset.saleAppliedFor) {
          cleanBlock(block);
          delete block.dataset.saleAppliedFor;
        }
        return;
      }

      if (block.dataset.saleAppliedFor === key) return;            
      if (block.dataset.saleAppliedFor) cleanBlock(block);         

      var applied = mode === 'fixed'
        ? applyFixed(block, key.charAt(0) === 'h' ? hFixed : (vFixed !== undefined ? vFixed : pFixed))
        : applyPct(block, vPct !== undefined ? vPct : pPct);

      if (applied) block.dataset.saleAppliedFor = key;
    });
  }

  var t;
  function debounced() {
    clearTimeout(t);
    t = setTimeout(applyOverrides, 200);
  }

  document.addEventListener('rebuy:smartcart.ready', debounced);
  document.addEventListener('rebuy:change', debounced);
  document.addEventListener('rebuy:smartcart:product-added', debounced);

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      new MutationObserver(debounced).observe(document.body, {
        childList: true,
        subtree: true
      });
      setTimeout(applyOverrides, 1500);
    });
  } else {
    new MutationObserver(debounced).observe(document.body, {
      childList: true,
      subtree: true
    });
    setTimeout(applyOverrides, 1500);
  }
})();